define('viewModels/widgets/ListEditor',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel',
    'util/keyCode'
], function (ko, _, ViewModel, keyCode) {

    'use strict';
    var ListEditor = ViewModel.extend(function () {
        var self = this;
        self.loadingList = ko.observable(true);

        self.listItems = ko.observableArray();

        self.addNewItemText = "";

        self.hasItems = self.computed(function () { return self.listItems().length > 0; });

        self.newItemValue = ko.observable("");

        self.addListItem = function() {
            self.listItems.push(ko.observable(self.newItemValue()));
            self.newItemValue("");
        };

        self.keyPressHandler = function (data, event) {
            if (event.keyCode == keyCode.ENTER){
                self.addListItem();
            } else {
                return true;
            }
        };

        self.removeListItemAtIndex = function(index) {
            self.listItems.splice(index, 1);
        };

        /**
         * The configure function for this view model.
         *  options:
         *      items: Observable array to edit. Can only contain observable strings.
         *      addNewItemTextKey: Localized string key for placeholder text for new item textbox.
         */
        self.configure = function (options) {
            var opts = _.assign({
                addNewItemTextKey: 'listEditor.addNewItem',
                items: ko.observableArray()
            }, options);

            self.listItems = opts.items;
            self.addNewItemText = ko.i18n.renderString(opts.addNewItemTextKey);
        };
    });

    return ListEditor;

});
